module.exports = __webpack_public_path__ + "img/purchases--icon.f4a64b63.svg";